import KeyValuePair from '@/modules/core/support/KeyValuePair'
import { AuthorizationItem } from '@/modules/authorization/model/AuthorizationItem'
import moment from 'moment'

/**
 * Permiso de usuario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Permission extends AuthorizationItem {
    public children: Permission[] = []

    /**
     * Permiso que un usuario debe poseer si quiere asignar este permiso a un rol
     */
    public assignToRolesPermission = ''

    /**
     * Elimina un permiso
     *
     * @param path
     */
    public deletePermission (path: string) {
        return this.removeChild(path)
    }

    public get assignToRolesPermissionList () {
        const list: string[] = []
        if (this.assignToRolesPermission) {
            list.push(this.assignToRolesPermission)
        }

        this.children.forEach((child: Permission) => {
            list.push(...child.assignToRolesPermissionList)
        })

        return list
    }

    /**
     * Convierte los datos planos en una entidad
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const permission = new this()
        permission.id = data.id
        permission.key = data.key
        permission.path = data.path
        permission.title = data.title
        permission.description = data.description
        permission.createdAt = moment(data.created_at, 'DD-MM-YYYY HH:mm:ss').toDate()
        permission.updatedAt = moment(data.update_at, 'DD-MM-YYYY HH:mm:ss').toDate()
        permission.assignToRolesPermission = data.assign_to_roles_permission || ''
        if (Array.isArray(data.children)) {
            permission.children = data.children.map((p: KeyValuePair) => Permission.deserialize(p))
        }

        return permission
    }

    /**
     * Convierte la entidad en un objeto plano para ser enviado al servidor
     */
    public serialize () {
        return {
            path: this.updatedPath,
            title: this.title,
            description: this.description,
            assign_to_roles_permission: this.assignToRolesPermission,
        }
    }
}
